import React from "react";
import Title from "../../../components/forms/productForms/title/title";
import Name from "../../../components/forms/userForms/name/name";
export default function SecondPageForm() {
  return (
    <>
      <Name />
      <Title />
    </>
  );
}
